import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daf8lihtto0ceqqnh820';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐：命中则给与正常反馈但不提交，避免机器识别
    const honey = ((fd.get('website_alt') as string) || '').trim();
    if (honey) {
      setStatus('success');
      return;
    }

    setStatus('loading');
    setFormError('');
    const payload: string[] = [];
    fd.forEach((value, key) => {
      if (key === 'website_alt') return;
      if (typeof value === 'string' && value.trim()) {
        payload.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.trim())}`);
      }
    });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.join('&'),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code as string | undefined;
      const metaMsg =
        (parsed?.meta as { message?: string } | undefined)?.message ||
        (parsed?.message as string | undefined) ||
        (parsed?.meta as { detail?: string } | undefined)?.detail ||
        '';

      if (res.ok && code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(metaMsg && !metaMsg.includes('spam') ? metaMsg : '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试');
    }
  }

  return (
    <form
      id="subscribe-form"
      data-readdy-form="subscribe-chigua-news"
      onSubmit={handleSubmit}
      noValidate
      className="flex flex-col gap-3 sm:flex-row"
    >
      <label htmlFor="subscribe-email" className="sr-only">
        您的邮箱
      </label>
      <input
        id="subscribe-email"
        type="email"
        name="email"
        required
        placeholder="输入邮箱，订阅每日吃瓜快讯"
        className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400 focus:ring-2 focus:ring-primary-200 sm:flex-1"
      />
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="gossip-honey"
      />
      <button
        type="submit"
        disabled={status === 'loading'}
        className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
      >
        {status === 'loading' ? '提交中…' : '立即订阅'}
      </button>

      {status === 'success' && (
        <p className="mt-2 flex items-center gap-1.5 text-sm text-secondary-800 sm:mt-0 sm:w-full">
          <i className="ri-checkbox-circle-fill text-secondary-600" aria-hidden="true" />
          订阅成功，感谢关注！我们会把最新深度报道发送到您的邮箱。
        </p>
      )}
      {status === 'error' && formError && (
        <p className="mt-2 flex items-center gap-1.5 text-sm text-primary-700 sm:mt-0 sm:w-full">
          <i className="ri-error-warning-fill" aria-hidden="true" /> {formError}
        </p>
      )}
    </form>
  );
}